import { pageSelectorGenerator } from '@test/pageSelectors';

export const ConfirmedPurchaseSelectors = pageSelectorGenerator('ConfirmedPurchase', ['ContainerElement', 'AllDoneButton']);
